import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcPauseSIcon, IcPlaySIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { VoiceHistogram } from 'APP/components/VoiceHistogram/VoiceHistogram';

import { usePreviewRecordPresenter } from './PreviewRecord.presenter';
import styles from './PreviewRecord.styles.m.css';

interface IPreviewRecordProps {
  className?: string;
}

export const PreviewRecord: FC<IPreviewRecordProps> = observer(({ className }) => {
  const {
    audioRef,
    src,
    histogram,
    isPlaying,
    time,
    progress,
    handlePlay,
    handlePause,
    onTimeUpdate,
    onEnded,
    onCanPlay,
    onChangeProgress,
  } = usePreviewRecordPresenter();

  return (
    <div className={className}>
      <div className={styles.container}>
        {!isPlaying && (
          <FAB
            Icon={IcPlaySIcon}
            onClick={handlePlay}
            size="10"
            theme="1"
          />
        )}
        {isPlaying && (
          <FAB
            Icon={IcPauseSIcon}
            onClick={handlePause}
            size="10"
            theme="1"
          />
        )}

        <VoiceHistogram
          className={styles.histogram}
          histogram={histogram}
          progress={progress}
          isMirrored={true}
          onChangeProgress={onChangeProgress}
        />

        <span className={styles.timer}>{time}</span>

        <audio
          src={src}
          ref={audioRef}
          onCanPlay={onCanPlay}
          onTimeUpdate={onTimeUpdate}
          onEnded={onEnded}
        />
      </div>
    </div>
  );
});
